import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { getDuration } from "../../utils";
const TimeLine = ({ start_date, end_date, role }) => {
  return (
    <Box w="40%">
      <Text color="rgb(226,232,240)" lineHeight="1.9" fontSize="1.25rem">
        {getDuration(start_date, end_date)}
        {/* April , 2023 */}
      </Text>
      <Text color={"rgb(203,213,225)"} lineHeight="1.25rem" fontSize="1.15rem">
        {role}
        {/* Web Developer */}
      </Text>
    </Box>
  );
};

export default TimeLine;
